import { FC } from 'react';
import { FavoriteToggle, MiddleButton, ContentControls } from '#baseMenu/components';
import menuControls from '../../assets/menu-controls.module.scss';

const Controls: FC = () => (
  <div className={menuControls.menuControls}>
    <FavoriteToggle />
    <MiddleButton />
    <ContentControls />
  </div>
);

export { Controls };
